<template>
    <b-container class="pb-2 bg-light mt-2 rounded">
        <page-heading heading="Maldives National Qualification Framework (MNQF)"/>
        <b-col cols="9" class="mx-auto text-left">
            <div class="lead pb-4">
                <span v-html="this.mnqf.value"></span>
            </div>
        </b-col>

        <page-heading heading="Objectives"/>
        <!-- Accordion starts here  -->
        <div role="tablist">
            <!-- Main wrap card -->
            <b-card class="">
                <!-- Accordion Elements -->
                <b-card no-body class="mb-2" bg-variant="info">
                    <b-card-header header-tag="header" role="tab">
                        <b-btn block v-b-toggle.accordion1 variant="link" class="underline-none pt-0 pb-0 text-white highlight-none">
                            MNQF Implementation Notes
                        </b-btn>
                    </b-card-header>            
                    <b-collapse id="accordion1" accordion="objectives" role="tabpanel">
                        <b-card-body>
                            <div class="card-text text-white text-left">
                                <span v-html="this.implementationNotes.value"></span>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
                
                <b-card no-body class="mb-2" bg-variant="info">
                    <b-card-header header-tag="header" role="tab">
                        <b-btn block v-b-toggle.accordion2 variant="link" class="underline-none pt-0 pb-0 text-white highlight-none">
                            Course Developer Notes    
                        </b-btn>
                    </b-card-header>    
                    <b-collapse id="accordion2" accordion="objectives" role="tabpanel">
                        <b-card-body variant="bg-white">
                            <div class="card-text text-white text-left">
                                <span v-html="this.developerNotes.value"></span>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-2" bg-variant="info">
                    <b-card-header header-tag="header" role="tab">
                        <b-btn block v-b-toggle.accordion3 variant="link" class="underline-none pt-0 pb-0 text-white highlight-none">
                            MNQF Features
                        </b-btn>
                    </b-card-header>            
                    <b-collapse id="accordion3" accordion="objectives" role="tabpanel">
                        <b-card-body variant="text-white">
                            <div class="card-text text-white text-left">
                                <span v-html="this.features.value"></span>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-2" bg-variant="info">
                    <b-card-header header-tag="header" role="tab">
                        <b-btn block v-b-toggle.accordion4 variant="link" class="underline-none pt-0 pb-0 text-white highlight-none">
                            MNQF Benefits
                        </b-btn>
                    </b-card-header>
                    <b-collapse id="accordion4" accordion="objectives" role="tabpanel">
                        <b-card-body variant="bg-white text-white">
                            <div class="card-text text-white text-left">
                                <span v-html="this.benefits.value"></span>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </b-card>
        </div>
        <h2 class="font-weight-light pt-3 text-center">Downloads</h2>
        <hr class="w-50 pb-2">
        <b-card >
            <b-card no-body class="mb-2" bg-variant="info">
                <b-card-header>
                    <b-btn block variant="link" v-b-toggle.collapse1 class="underline-none pt-0 pb-0 text-white highlight-none">
                        MNQF Framework V2.2
                    </b-btn>
                </b-card-header>
                <b-collapse id="collapse1">
                    <b-card-body>
                        <ul class="list-unstyled text-white">
                            <li><a href="/static/uploads/Maldives-National-Qualifications-Framework-V2_2-witheffectfrom01stJan2017_2018-06-26T00-49-48.pdf" class="text-white underline-none">Maldives National Qualifications Framework V2.2 (Effective: 01st Jan 2017)</a></li>
                            <hr>
                            <li><a href="/static/uploads/Entry-Criteria-for-MNQF-Qualifications-with-effect-from-01st-Jan-2017-7_11_2-16-BM9_2018-06-26T00-43-32.pdf" class="text-white underline-none">Entry Criteria for MNQF Qualifications (Effective: 01st Jan 2017)</a></li>
                        </ul>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card no-body class="mb-2" bg-variant="info">
                <b-card-header>
                    <b-btn block variant="link" v-b-toggle.collapse2 class="underline-none pt-0 pb-0 text-white highlight-none">
                        MNQF 2009 Full Text
                    </b-btn>
                </b-card-header>
                <b-collapse id="collapse2">
                    <b-card-body>
                        <ul class="list-unstyled">
                            <li><a href="/static/uploads/MNQF2009withAmmendment1_2018-06-26T00-45-48.pdf" class="text-white underline-none">MNQF 2009 with Ammendment 1</a></li>
                        </ul>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </b-card>
    </b-container>
</template>
<script>
import PageHeading from '@/components/SharedComponents/PageHeading.vue'
import axios from 'axios'
export default {
    data() {
        return{
            mnqf: [],
            implementationNotes: [],
            developerNotes: [],
            features: [],
            benefits: []
        }
    },
    methods: {
        getMNQF(){
            axios.get(this.API_URL + '/mnqf').then((response) => {
                this.mnqf = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getImplementation(){
            axios.get(this.API_URL + '/mnqf/implementation_notes').then((response) => {
                this.implementationNotes = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getDeveloper(){
            axios.get(this.API_URL + '/mnqf/developer_notes').then((response) => {
                this.developerNotes = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getFeatures(){
          axios.get(this.API_URL + '/mnqf/features').then((response) => {
                this.features = response.data
            }, (error) => {
                console.log(error)
            })  
        },

        getBenefits(){
            axios.get(this.API_URL + '/mnqf/benefits').then((response) => {
                this.benefits = response.data
            }, (error) => {
                console.log(error)
            })
        }
    },
    components: {
        PageHeading
    },
    beforeCreate() {
        document.title = "MNQF";
    },
    created() {
        
    },
    beforeMount() {
        
    },
    mounted() {
        this.getMNQF()
        this.getImplementation()
        this.getDeveloper()
        this.getFeatures()
        this.getBenefits()
    },
    beforeUpdate() {
        
    },
    updated() {

    }
}
</script>
<style scoped>
    .underline-none{
        text-decoration: none !important;
    }
    .highlight-none{
        outline: none !important;
        box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/mnqf.vue